import { isNil } from 'lodash';

import { IVROption, SerializableObjectWithNoParams, SupportedLanguages, VoiceResponseCommand } from '@pwp-common';

import { ServiceCommandEditorOutput } from '../../../../service-operation-editor/editor-output/service-command-editor-output';
import { defaultIVROptionEditorOutput } from '../default-ivr-option-editor-output';
import { IVROptionEditorOutput } from '../ivr-option-editor-output';

const serializeCommand = (command: VoiceResponseCommand): ServiceCommandEditorOutput =>
  (command as unknown as SerializableObjectWithNoParams).serialize() as ServiceCommandEditorOutput;

export const dbToIVROptionEditorOutput = (ivrOption: IVROption | undefined | null): IVROptionEditorOutput => {
  if (isNil(ivrOption)) {
    return defaultIVROptionEditorOutput;
  }

  const phrases = ivrOption.getPhrases().get(SupportedLanguages.en.getShortCode()) ?? [];
  const commands = ivrOption.getCommands().map(serializeCommand);

  return {
    displayName: ivrOption.getDisplayName(),
    description: ivrOption.getDescription(),
    keyPresses: ivrOption.getKeyPresses(),
    phrases,
    commands: { commands },
  };
};
